import { render, staticRenderFns } from "./table-tr-ttl-monthly-goal-registration.page.vue?vue&type=template&id=6f5ff9f4"
import script from "./table-tr-ttl-monthly-goal-registration.page.vue?vue&type=script&lang=ts"
export * from "./table-tr-ttl-monthly-goal-registration.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports